(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-load-more-url]');
    if (!button || button.hasAttribute('aria-busy')) return;

    const sectionId = button.getAttribute('data-load-more-section');
    const nextUrl = button.getAttribute('data-load-more-url');
    const grid = document.getElementById('Slider-' + sectionId);
    if (!grid || !nextUrl) return;

    button.setAttribute('aria-busy', 'true');
    button.querySelectorAll('.show-more-button__label').forEach(function (label) {
      label.hidden = !label.hidden;
    });

    const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
    const fetchUrl = nextUrl + separator + 'section_id=' + encodeURIComponent(sectionId);

    fetch(fetchUrl)
      .then(function (response) {
        if (!response.ok) throw new Error(response.status);
        return response.text();
      })
      .then(function (responseText) {
        const parsed = new DOMParser().parseFromString(responseText, 'text/html');
        const newGrid = parsed.getElementById('Slider-' + sectionId);
        const wrap = button.closest('[data-load-more-wrap]');

        if (newGrid) {
          let index = grid.children.length;
          Array.from(newGrid.children).forEach(function (item) {
            index += 1;
            item.id = 'Slide-' + sectionId + '-' + index;
            grid.appendChild(item);
          });
        }

        const nextButton = parsed.querySelector('[data-load-more-url]');
        if (nextButton) {
          button.setAttribute('data-load-more-url', nextButton.getAttribute('data-load-more-url'));
          button.removeAttribute('aria-busy');
          button.querySelectorAll('.show-more-button__label').forEach(function (label) {
            label.hidden = !label.hidden;
          });
        } else if (wrap) {
          wrap.remove();
        }
      })
      .catch(function () {
        button.removeAttribute('aria-busy');
        button.querySelectorAll('.show-more-button__label').forEach(function (label) {
          label.hidden = !label.hidden;
        });
      });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  (function () {
    const bar = document.querySelector('.page-loading-bar');
    if (!bar) return;

    document.addEventListener('click', function (event) {
      if (event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      const link = event.target.closest('a[href]');
      if (!link) return;
      if (link.target && link.target !== '_self') return;
      if (link.hasAttribute('download')) return;

      let url;
      try {
        url = new URL(link.href, window.location.href);
      } catch (error) {
        return;
      }

      if (url.origin !== window.location.origin) return;
      // Same-page anchor links (e.g. "#section") don't trigger a real page load.
      if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash) return;

      bar.classList.add('page-loading-bar--active');

      // The view transition below can capture/freeze the page for its "old page" snapshot
      // within a frame or two of this click, long before a slow transition has animated
      // anything visible. Jump the bar to a partway width instantly (no transition) so it's
      // already clearly on-screen in that very first frame, then let the class's transition
      // take over for any remaining wait time.
      bar.style.transition = 'none';
      bar.style.transform = 'scaleX(0.5)';
      bar.offsetWidth;
      bar.style.transition = '';
      bar.style.transform = '';

      // If this link lives inside the open hamburger drawer, let it play its normal slide-shut
      // animation first instead of being cut off mid-open the instant the page navigates away.
      const drawer = link.closest('header-drawer');
      const isDrawerOpen = drawer && drawer.querySelector('details[open]');
      if (isDrawerOpen) {
        event.preventDefault();
        // closeMenuDrawer() doesn't touch aria-expanded itself (only the hamburger's own click
        // listener does), so without this the dark backdrop's fade-out would never trigger here.
        const summary = drawer.querySelector('#Details-menu-drawer-container > summary');
        if (summary) summary.setAttribute('aria-expanded', 'false');
        drawer.closeMenuDrawer({});
        // Matches the 400ms duration MenuDrawer.closeAnimation waits before it actually
        // removes the "open" attribute, so navigation only happens once the slide is done.
        setTimeout(function () {
          window.location.href = link.href;
        }, 400);
      }
    });

    // If the page is restored from the back/forward cache, reset the bar for next time.
    window.addEventListener('pageshow', function () {
      bar.classList.remove('page-loading-bar--active');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('load-more-products')) {
    customElements.define(
      'load-more-products',
      class LoadMoreProducts extends HTMLElement {
        connectedCallback() {
          this.button = this.querySelector('button');
          if (!this.button) return;
          this.loading = false;
          this.button.addEventListener('click', () => this.loadMore());

          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(
              (entries) => {
                if (entries.some((entry) => entry.isIntersecting)) this.loadMore();
              },
              { rootMargin: '600px 0px' }
            );
            this.observer.observe(this);
          }
        }

        disconnectedCallback() {
          if (this.observer) this.observer.disconnect();
        }

        setLoading(state) {
          this.loading = state;
          this.button.disabled = state;
          this.querySelectorAll('.load-more__label').forEach((label) => {
            label.hidden = !label.hidden;
          });
        }

        loadMore() {
          const url = this.dataset.url;
          const sectionId = this.dataset.sectionId;
          if (this.loading || !url) return;
          this.setLoading(true);

          const separator = url.indexOf('?') === -1 ? '?' : '&';
          fetch(`${url}${separator}section_id=${encodeURIComponent(sectionId)}`)
            .then((response) => {
              if (!response.ok) throw new Error(response.status);
              return response.text();
            })
            .then((text) => {
              const parsed = new DOMParser().parseFromString(text, 'text/html');
              const currentGrid = document.getElementById('product-grid');
              const newGrid = parsed.getElementById('product-grid');
              if (currentGrid && newGrid) {
                Array.from(newGrid.children).forEach((item) => currentGrid.appendChild(item));
              }

              const nextLoader = parsed.querySelector('load-more-products');
              if (nextLoader) {
                this.dataset.url = nextLoader.dataset.url;
                this.setLoading(false);
              } else {
                this.remove();
              }
            })
            .catch(() => {
              this.setLoading(false);
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
